import mutationTypesBM100 from "../../store/globalTemplateSpecificModules/storeModulesBM100/mutationTypesBM100";

let timeoutId = null;

export const autoHideOldBasketWithDelay = (self) => {
	const value = self.$store.getters.tenantSettings.timers.autoHideBasketInMs;
	const autoHide = ["0", 0, null, undefined, ""].includes(value) ? false : true;
	if (autoHide) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			autoHideOldBasket(self, timeoutId);
		}, value);
	}
};

export const autoHideOldBasket = (self, clearTimeoutId) => {
	clearTimeout(clearTimeoutId);
	self.$store.commit(mutationTypesBM100.CHANGE_BASKET_STATE_CONTROL, "hide");
};

export const preventAutoHideOldBasket = () => {
	clearTimeout(timeoutId);
};
